/**
 * Orden estándar de tallas para productos (prendas y otros)
 */
export const DEFAULT_SIZES_ORDER = [
    'XS / ECH',
    'S / CH',
    'M / MED',
    'L / GR',
    'XL / EXGR',
    '2XL / 2EXGR',
    '3XL / 3EXGR',
    '28',
    '30',
    '32',
    '34',
    '36',
    '38',
    '40',
    '42',
    '44',
    '46',
    '48',
    '50'
];

/**
 * Ordena un array de tallas según el orden estándar.
 * Las tallas no definidas en el orden se colocan al final.
 */
export function sortSizesByOrder(
    sizes: string[],
    order: string[] = DEFAULT_SIZES_ORDER
): string[] {
    return [...sizes].sort((a, b) => {
        const indexA = order.indexOf(a);
        const indexB = order.indexOf(b);
        if (indexA === -1 && indexB === -1) return a.localeCompare(b);
        if (indexA === -1) return 1;
        if (indexB === -1) return -1;
        return indexA - indexB;
    });
}
